import execFor from '@utils/platform/execFor';
import { setMetrics, selectedMetricChart } from '@store/metricsChartContainer/actions';
import {
  setDimensionMetrics,
  setDimensions,
  setGlobalOrderByMetric,
} from '@store/trends/base/actions';

export const initOdp = execFor.odp(({ userDefinedMetrics, dispatch, dimensionList }) => {
  if (userDefinedMetrics && userDefinedMetrics.odp) {
    const odpMetrics = userDefinedMetrics.odp;
    // trends needs a selected metric and dimension
    const defaultMetric = odpMetrics.session_count;
    dispatch(setMetrics(Object.keys(odpMetrics).slice(0, 3)));
    dispatch(selectedMetricChart(defaultMetric.name));
    dispatch(setDimensionMetrics([defaultMetric.name]));
    dispatch(setGlobalOrderByMetric(defaultMetric.name));

    if (dimensionList.length > 0) {
      const dimensions = dimensionList.slice(0, 3).map((d) => d.groupBy);
      dispatch(setDimensions(dimensions));
    }
  }
});
